export class Resource{
  /**
   * @param {Resource} opts
   */
  constructor(opts = {}){
    /** @type {string} */
    this.id = opts.id
    /** @type {string} */
    this.type = opts.type
    /** @type {boolean} */
    this.loaded = false
  }
  toJSON(){
    let obj = { ...this }
    delete obj.loaded
    return obj
  }
}
export class AudioResource extends Resource{
  /**
   * @param {AudioResource} opts
   */
  constructor(opts = {}){
    opts.type = 'audio'
    super(opts)
    /** @type {string} */
    this.src = opts.src
    // undefined & null => true
    // eslint-disable-next-line no-unneeded-ternary
    this.preload = opts.preload === false ? false : true
  }
}
export class ImageResource extends Resource{
  /**
   * @param {ImageResource} opts
   */
  constructor(opts = {}){
    opts.type = 'image'
    super(opts)
    /** @type {string} */
    this.src = opts.src
    // undefined & null => true
    // eslint-disable-next-line no-unneeded-ternary
    this.preload = opts.preload === false ? false : true
  }
}
export default Resource
